<template>
  <SectionIndonesiaHero/>

  <SectionIndonesiaContent_Section/>
  <SectionIndonesiaContent_Section_1/>
  <SectionIndonesiaContent_Testimonials/>
  <SectionIndonesiaContent_Section_2/>
  <SectionIndonesiaContent_Section_3/>
<!--  <SectionIndonesiaContent_Testimonials/>-->
  <SectionHealthyCoffeeSwatches/>
  <SectionIndonesiaContent_Section_5/>
  <SectionIndonesiaContent_Section_6/>
<!--  <SectionIndonesiaContent_Section_7/>-->
  <SectionIndonesiaContent_Section_8/>
  <SectionIndonesiaContent_Section_9/>
  <SectionIndonesiaContent_Section_10/>
  <SectionIndonesiaFooter/>
</template>


<script setup>

useSeoMeta({
  layout:() => "default",
  title: () => "Indonesian Organic Coffee | Lifeboost Coffee",
  description: () => "Experience the rich, full-bodied flavor of our organic coffee from the damp morning air of northern Sumatra, Indonesia. Each cup is a testament to community, resilience, and sustainability. Our beans are single-origin, pesticide-free, and grown at high elevations for exceptional flavor.",
})

</script>